// extracted by mini-css-extract-plugin
export default {"container":"aboutCard_container__hiUwC","text":"aboutCard_text__u404+","btns":"aboutCard_btns__ftw7H"};